import React from "react";
import { useDispatch } from "react-redux";
import { toggleThumbnailDrawer } from "../actions/navigationActions";

const HoverActivator = () => {
  const dispatch = useDispatch();

  const handleMouseEnter = () => {
    dispatch(toggleThumbnailDrawer(true));
  };

  return <div className="hover-activator" onMouseEnter={handleMouseEnter} />;
};

export default HoverActivator;
